import { render, staticRenderFns } from "./informationTable.vue?vue&type=template&id=706cf5df&"
import script from "./informationTable.vue?vue&type=script&lang=js&"
export * from "./informationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports